
import request from '../../src/util/request'
 

// get请求
export function postPv(url,params) {
    return request({
        url:url, // 请求路径，会自动拼接上baseUrl
        method: 'get',
    })
}
 